import React from 'react';
import PrefixedTextField from './PrefixedTextField';
import TPrefixedTextField from './@types/PrefixedTextField';

// TODO: Check if we want to use formatter for the value (Dutch format), I'm not sure if we want to do this here
const MonetaryTextField = ({ prefixText = '€', value, ...props }: TPrefixedTextField) => {
  return <PrefixedTextField {...props} prefixText={prefixText} type="text" value={value} />;
};

export default MonetaryTextField;
